/*@ngInject*/
const ReportMediator = function ($q, reportRepository) {

    this.getReportList = function (submissionId) {
        return reportRepository.getReportList(submissionId);
    };
};

angular.module('gw-um-submission')
    .service('reportMediator', ReportMediator);
